import api from './api';

/**
 * Notification Service
 * Handles all notification-related API calls
 */
const notificationService = {
    /**
     * Get all notifications
     * @param {Object} params - Query parameters (page, limit)
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/notifications${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Mark notification as read
     * @param {string} id - Notification ID
     * @returns {Promise<Object>}
     */
    markAsRead: async (id) => {
        return api.patch(`/user/notifications/${id}/read`);
    },

    /**
     * Mark all notifications as read
     * @returns {Promise<Object>}
     */
    markAllAsRead: async () => {
        return api.patch('/user/notifications/read-all');
    },

    /**
     * Get unread count
     * @returns {Promise<Object>}
     */
    getUnreadCount: async () => {
        return api.get('/user/notifications/unread-count');
    }
};

export default notificationService;
